import React, { JSX } from 'react';
import { getFormatDateFromStoreDate } from 'shared-components';
import { Section } from '../../../../Finger/Section';
import { getFingerStatus, getVisible, hasDeleted } from '../../../../../utilities/documents';
import FingerWithApprove from '../../../../atoms/finger-with-approve';
import NoDocuments from '../../../../atoms/no-doc-placeholder';

import { UserRole } from '../../../../../store/auth/types';
import { SummaryRow } from '../../../../Summary/SummaryRow';

import { VisaVignetteDocList, IFollowUpDocuments, DocAccessType } from '../../../../../types';
import { useTranslation } from "react-i18next";

interface IProps {
  userAccess?: DocAccessType;
  documents: IFollowUpDocuments['afterArrival']['stampedVisaVignette'];

  userRole?: UserRole;

  canResume: boolean;
  canUpload: boolean;
  canOpen: boolean;
  canApprove: boolean;
  canReject: boolean;
  isDeleting: boolean;

  onUploadClick: (docKey: string) => void;
  onOpenClick: (docKey: string) => void;
  onApproveClick: (docKey: string) => void;
  onRejectClick: (docKey: string) => void;
  onRescindRejectClick: (docKey: string) => void;
  onDeleteClick: (docKey: string) => void;
  onAcknowledgeClick: (docKey: string) => void;
}
const StampedVisaVignette = (props: IProps): JSX.Element => {
    const { t } = useTranslation('common');
  const { documents: visaVignetteDocs, userAccess, userRole } = props;

  const visibleDocs = getVisible({ documentsHash: visaVignetteDocs, userAccess, userRole });

  const hasDocs = visibleDocs.length > 0;
  const hasDeletedDocs = hasDeleted(visaVignetteDocs);

  const docNodes: React.ReactNode[] = [];

  if (!hasDocs && !hasDeletedDocs) {
    return null;
  }

  if (userAccess && !hasDocs) {
    return null;
  }

  const getDocumentCount = (docs: object, index: number): string => {
    if (Object.keys(docs ?? {}).length <= 1) return '';

    return index > 0 ? String(index + 1) : '';
  };

  if (hasDocs) {
    docNodes.push(
      ...visibleDocs.map((stampedVisaVignette: VisaVignetteDocList, stampedVignetteIndex: number) => {
        const { key: docKey, item } = stampedVisaVignette;
        return (
          <FingerWithApprove
            id={`stamped-visa-vignette-${docKey}`}
            key={`stamped-visa-vignette-${docKey}`}
            status={getFingerStatus(item)}
            isProcessingPdf={item.isProcessingPdf}
            reason={item.reason}
            fileCount={item.signedUrls && item.signedUrls.length > 0 ? item.signedUrls.length : 0}
            fileNames={item.fileNames}
            label={t('common:stampedStudentVisaEvisa', { getDocumentCount: getDocumentCount(visaVignetteDocs, stampedVignetteIndex) })}
            canUpload={props.canUpload}
            canOpen={props.canOpen}
            canApprove={props.canApprove}
            canReject={props.canReject}
            isDeleting={props.isDeleting}
            canAcknowledge={false}
            onUploadClick={() => {
              props.onUploadClick(docKey);
            }}
            onOpenClick={() => {
              props.onOpenClick(docKey);
            }}
            onApproveClick={() => {
              props.onApproveClick(docKey);
            }}
            onRejectClick={() => {
              props.onRejectClick(docKey);
            }}
            onRescindRejectClick={() => {
              props.onRescindRejectClick(docKey);
            }}
            onDeleteClick={() => {
              props.onDeleteClick(docKey);
            }}
            onAcknowledgeClick={() => {}}
            userRole={props.userRole}
            deletedByTTL={item.deletedByTTL}
          >
            <SummaryRow
              key={`after-arrival-start-date-${docKey}`}
              label={t('common:visaStartDate')}
              fullLabel="What is the visa start date?"
              value={getFormatDateFromStoreDate(item.visaStartDate)}
            />

            <SummaryRow
              key={`after-arrival-end-date-${docKey}`}
              label={t('common:visaEndDate')}
              fullLabel="What is the visa end date?"
              value={getFormatDateFromStoreDate(item.visaEndDate)}
            />
          </FingerWithApprove>
        );
      }),
    );
  }

  return (
    <>
      <Section
        key={`after-arrival`}
        label={t('common:uploadYourPassportVisaPageWithAU')}
        canEdit={false}
        warning={''}
      >
        {hasDocs ? docNodes : <NoDocuments />}
      </Section>
    </>
  );
};

export default StampedVisaVignette;
